// The title comes from the model and is rendered as text only, never injected
// as HTML.

import { isNumber, isString } from "../utils/schemaUtils";

export interface SessionDocumentPayload {
  type: "session_document";
  version: number;
  artifactId: string;
  title: string;
  kind: string;
}

export const parseSessionDocumentPayload = (v: unknown): SessionDocumentPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "session_document") return null;
  if (!isNumber(r.version)) return null;
  if (!isString(r.artifactId) || !isString(r.title) || !isString(r.kind)) return null;
  return {
    type: "session_document",
    version: r.version,
    artifactId: r.artifactId,
    title: r.title,
    kind: r.kind,
  };
};
